module.exports = __webpack_public_path__ + "img/enabled_selected.1559d51e.svg";